<template>
  <div >
    <BreadCrumb :data="breadCrumb" />
    <Table
      :fields="fields" :items="faultSupportsList" :filtered="filtered" type="List" 
      :loading="isLoading" :limit="limit" :setLimit="setLimit" :page="page" :setPage="setPage" 
      :pageData="pageInfo" :actions="actions" :actionEvent="actionEvent" :goDetail="goDetails" 
      :inputs="inputs" :search="search" :gSearch='gSearch' addUrl="Stock/FaultSupports/Add"
    />
    <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import Table from "@/components/Table";
import Modals from "./modals/";
import i18n from "@/plugins/i18n";

let breadCrumb = [
  { label: "Stoklar", url: "/Stock/List" },
  { label: "Arıza Destekleri", url: "/Stock/FaultSupports" }
  ];

let fields = [
  { key: "fault_support_no", label: "Arıza Takip No", keys: ["fault_support_no"] },
  { key: "product", label: "Ürün İsmi", keys: ["product", "name"] },
  { key: "product_serial_number", label: "Seri No", keys: ["product_serial_number"] },
  { key: "customer", label: "Müşteri", keys: ["customer", "name"] },
  { key: 'warranti_date', type: "expiredIn", label: "Garanti Bitiş", keys:['warranti_date'] },
  { key: 'expiredIn', type:"expiredIn", label: "Teslim Tarihi", keys:['delivery_date'] },
  { key: "status", type:"multipleBadge", label: "Durum", keys: [["status"], ['fault_support_result', 'name']] },
  { key: 'DeviceStatus', type:"data", label: "Cihaz Durumu", data:{
    true: {text: 'Bizde', variant: 'success' }, false: {text: 'Müşteride', variant: 'danger' }}, keys:['fault_product_change', 'did_reach'] },
  { key: "actions", label: "İşlemler" },
];
let inputs = [
  { key: "productName", label: "Ürün Adı", type: "String", checked: false, val: "" },
  { key: "customerName", label: "Müşteri İsmi", type: "String", checked: false, val: "" },
  { key: "productSerialNumber",label: "Seri No",type: "String",checked: false,val: "",},
  { key: "username", label: "Atanan Kullanıcı", type: "String", checked: false, val: "" },
  { key: "status", label: "Durum", type: "Select",checked: false,val: "", array: [
      { text: "Aktif", value: "open" },
      { text: "Pasif", value: "close" }
    ]},
  { key: "didReach", label: "Cihaz Durumu", type: "Select", array:[
    {text: 'Bütün Cihazlar', value: 0},
    {text: 'Müşterideki Cihazlar', value: 1},
    {text: 'Bize Ulaşan Cihazlar', value: 2},
  ], checked: false, val: "" },

];
let actions = [
  { key: "image", text: "Desteğe Resim Ekle" },
  { key: "movement", text: "Yeni Arıza Hareketi Ekle" },
  { key: "close", text: "Desteği Sonlandır" },
  { key: "report", text: "Rapor Al"}
];
let filtered = ["fault_support_no", "product", "product_serial_number", "customer", "warranti_date",  "status", "actions", 'DeviceStatus', "expiredIn"];

export default {
  name: "faultSupportsList",
  watch: {
    limit(val) {
      this.params["limit"] = val;
      this.$store.dispatch("fetchFaultSupports", this.params);
    },
    offset(val) {
      this.params["offset"] = val;
      this.$store.dispatch("fetchFaultSupports", this.params);
    },
  },
  data: function () {
    return {
      breadCrumb, fields, filtered, limit: 10, page: 1, offset: 0, actions,
      modalOpen: false, modalProps: {}, currentForm: "faultSupports", modalName: "",
      dismissCountDown: 0, inputs,
      params: {
        limit: 10,
        offset: 0,
      },
    };
  },
  components: {
    BreadCrumb,
    Table,
    Modals
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
    faultSupportsList() {
      return this.$store.getters.faultSupportsList
    },
    pageInfo(){
        return this.$store.getters.getFaultSupportPageInfo
    }
  },
  methods: {
    search(){
      this.inputs.map((input) => {
        input.checked ? this.params[input.key] = input.val : delete this.params[input.key] 
      })
      this.$store.dispatch('faultsupports_get', this.params)
    },
    gSearch(data){
      data.length > 0 ? this.params['search'] = data : delete this.params['search']
      this.$store.dispatch('faultsupports_get', this.params)
    },
    goDetails(item) {
      this.$router.push({ path: `FaultSupports/${item.id}` });
    },
    setLimit: function (limit) {
      this.limit = limit;
    },
    setPage: function (page) {
      if (page > 0) {
        this.page = page
        this.offset = ((page-1) * this.limit)
      }
    },
    actionEvent: async function (key, data) {
      this.openModal(true, key, { ...data, type: key })
    },
    openModal: function(state, modal, props){
      this.modalOpen = state
      if(state){
        this.modalProps = props
        this.modalName = modal
      }
    },
  },
  created() {
    this.$store.dispatch('faultsupports_get', this.params);
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/FaultSupportsList.vue